import "../../style/mobile/dashboard/M_MyExam.css";
import icon1 from "../../../assets/mobile/dashboard/vuesax-linear-task-square.svg";
import icon2 from "../../../assets/mobile/dashboard/vuesax-linear-stickynote.svg";
import icon3 from "../../../assets/mobile/dashboard/vuesax-linear-clock.svg";
import img1 from "../../../assets/mobile/dashboard/morteza-f-shojaei-8K9UGVCZGpw-unsplash (1).png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import React from "react";
import moment from "jalali-moment";
let tab_data = [
  {
    id: 1,
    tab_name: "همه",
    isActive: true,
  },
  {
    id: 2,
    tab_name: "آزمون‌های‌جاری",
    isActive: false,
  },
  {
    id: 3,
    tab_name: "آزمون‌های‌آینده",
    isActive: false,
  },
  {
    id: 4,
    tab_name: "آزمون‌های در حال برگزاری",
    isActive: false,
  },
];

const M_MyExam = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    className: "m-myExam-tab-content-slider-item",
  };
  const state = useSelector((state) => state.default);
  const [data] = useState(state.ExamData); //ExamData --> MyExamData
  const [TabData, setTabData] = useState(tab_data);
  //create tab data---------------------------------------------
  let all_tab_data = data.filter((item, index) => {
    return index < 8;
  });
  let thisWeek_tab_data = data.filter((item, index) => {
    return index < 8 && item.time_type === "thisWeek";
  });
  let future_tab_data = data.filter((item, index) => {
    return index < 8 && item.time_type === "future";
  });
  let live_tab_data = data.filter((item, index) => {
    return index < 8 && item.time_type === "live";
  });
  const [processing_data, set_processing_data] = useState(all_tab_data);
  //change tab----------------------------------------------------
  const [old_tab_id, set_old_tab_id] = useState(1);
  // const [active_tab,set_active_tab] = useState('all');
  const change_tab = (id) => {
    // console.log("tab" + id);
    let new_TabData = TabData.map((item) => {
      if (item.id === old_tab_id) {
        item.isActive = false;
      }
      if (item.id === id) {
        item.isActive = true;
      }
      return item;
    });
    setTabData(new_TabData);
    set_old_tab_id(id);
    if (id === 1) {
      set_processing_data(all_tab_data);
    } else if (id === 2) {
      set_processing_data(thisWeek_tab_data);
    } else if (id === 3) {
      set_processing_data(future_tab_data);
    } else if (id === 4) {
      set_processing_data(live_tab_data);
    }
  };
  moment.locale("en");
  return (
    <div className="m-myExam">
      <div className="m-myExam-title-box">
        <img
          className="m-myExam-title-box-icon"
          src={icon1}
          alt="myExam-icon"
        />
        <div className="m-myExam-title-box-text">لیست آزمون‌های من</div>
      </div>
      <div className="m-myExam-tab-btn-container">
        {TabData.map((item) => (
          <div
            key={item.id}
            onClick={() => change_tab(item.id)}
            style={
              item.isActive
                ? { backgroundColor: "#2E81E8", color: "white" }
                : null
            }
            className="m-myExam-tab-btn-item"
          >
            {item.tab_name}
          </div>
        ))}
      </div>
      <div className="m-myExam-tab-content">
        <Slider {...settings}>
          {processing_data.map((item, index) => (
            <React.Fragment key={index}>
              <div className="m-myExam-tab-content-item" key={item.id}>
                <img
                  className="m-myExam-tab-content-item-img-bg"
                  src={img1}
                  alt="exam-bg"
                />
                <div className="m-myExam-tab-content-item-cover"></div>
                <div className="m-myExam-tab-content-item-info">
                  <div className="m-myExam-tab-content-item-info-row1">
                    <img
                      src={icon2}
                      alt="exam-name-icon"
                      className="m-myExam-tab-content-item-info-row1-icon"
                    />
                    <div className="m-myExam-tab-content-item-info-row1-text">
                      {item.name}
                    </div>
                  </div>
                  <div className="m-myExam-tab-content-item-info-row2">
                    <div className="m-myExam-tab-content-item-info-row2-date-box">
                      <img
                        src={icon3}
                        alt="clock-icon"
                        className="m-myExam-tab-content-item-info-row2-date-box-img"
                      />
                      <div className="m-myExam-tab-content-item-info-row2-date-box-text">
                        {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
                      </div>
                    </div>
                    <div className="m-myExam-tab-content-item-info-row2-time-box">
                      ساعت <span>
                        {moment(item.date, 'YYYY/MM/DD HH:mm').locale("fa").format('HH:mm')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default M_MyExam;
